import React from 'react';
import {
    formatManagementGeneratedOn,
    formatReferencePeriodTitle,
} from '../utils/managementOverviewFormatters';
import {ReferencePeriod} from '../types/ManagementOverviewReport.types';

interface ReportHeaderProps {
    customerName: string;
    referencePeriod: ReferencePeriod;
    generatedOn: string;
    stationName?: string;
    showFullTitle: boolean;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
    customerName,
    referencePeriod,
    generatedOn,
    stationName,
    showFullTitle,
}) => {
    const updateLabel = `Atualização: ${formatManagementGeneratedOn(generatedOn)}`;

    if (showFullTitle) {
        return (
            <header className="management-overview-header management-overview-header--full">
                <img
                    src={`${process.env.PUBLIC_URL}/logo512.png`}
                    alt=""
                    className="management-overview-header__logo"
                />
                <div className="management-overview-header__text">
                    <h1 className="management-overview-title">
                        Relatório de Gestão Mensal — Resumo Geral
                    </h1>
                    <p className="management-overview-header-line">
                        Resumo Geral | {customerName}
                    </p>
                    {stationName ? (
                        <p className="management-overview-header-line">Usina - {stationName}</p>
                    ) : null}
                    <p className="management-overview-header-line management-overview-header-line--muted">
                        Período de referência:{' '}
                        {formatReferencePeriodTitle(referencePeriod.month, referencePeriod.year)}
                    </p>
                </div>
                <p className="management-overview-header__update">{updateLabel}</p>
            </header>
        );
    }

    return (
        <header className="management-overview-header management-overview-header--compact">
            <p className="management-overview-station-name">Usina - {stationName}</p>
            <p className="management-overview-header__update management-overview-header__update--compact">
                {updateLabel}
            </p>
        </header>
    );
};

export default ReportHeader;
